/// <reference types="vite/client" />
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import { initSentry, sentryErrorHandler } from '@/modules/sentry';
import { Toaster } from '@kognitos/lattice';
import '@/shared/i18n';

import router from './routes';
import { Providers } from './providers.tsx';
import './index.css';

// Initialize Sentry with project configuration
initSentry();

const root = createRoot(document.getElementById('root')!, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: sentryErrorHandler,
});
root.render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
      <Toaster position="bottom-right" />
    </Providers>
  </StrictMode>,
);
